import Vue from 'vue';
import Vuex, {Store} from 'vuex';
import {AscDesc, ResultType, XHTTPService} from '@/shared/xhttp';
import {
	PaginatorFilterState,
	PaginatorActionWithFilters,
	PaginatorMutation,
	StandardAction,
} from '@/shared/utils';
import {Client} from '@/models';
import {ClientService} from "@/xhttp/ClientService";

import {DateFilter} from '@/shared/filter';
import store from '@/stores';

Vue.use(Vuex);

export class ClientFilter {

	name: string = '';
	email: string = '';
	remarques: string = '';
	address: string = '';
	zipCode: string = '';
	town: string = '';
	country: string = '';

	public clear(): void {
		this.name = '';
		this.email = '';
		this.remarques = '';
		this.address = '';
		this.zipCode = '';
		this.town = '';
		this.country = '';
	}

	public toString(): string {
		return JSON.stringify(this);
	}
}

class ClientState extends PaginatorFilterState<ClientFilter> {
	client: Client = null;
	clients: ResultType<Client> = null;
	public constructor() {
		super(new ClientFilter(), 'clients', 'client', 'id', AscDesc.DESC, 20)
	}
}

class ClientStore {

	@XHTTPService(() => Client)
	private clientService: ClientService;
	private  _store: Store<any>;

	public state: ClientState = new ClientState();

	public mutations = {
		...PaginatorMutation(() => this._store, 'clients', 'client'),
	};

	public actions = {
		...StandardAction<Client, ClientState>(() => Client, 'client'),
		...PaginatorActionWithFilters<Client, ClientState>(() => Client, 'clients', 'client'),
	};

	public init(store: Store<any>): this {
		this._store = store;
		return this;
	}

}

const instance = new ClientStore();
const storeClient = new Vuex.Store(instance);
instance.init(storeClient);

const instancePrix = new ClientStore();
export const storeClientPrix = new Vuex.Store(instancePrix);
instancePrix.init(storeClientPrix);

store.registerModule('client', storeClient);
store.registerModule('clientPrix', storeClientPrix);
export default storeClient;